
let util = {

};
util.title = function (title) {
  title = `${title} - 财务清算管理系统V1.0`;
  window.document.title = title;
};

util.inOf = function (arr, targetArr) {
  let res = true;
  arr.forEach(item => {
    if (targetArr.indexOf(item) < 0) {
      res = false;
    }
  });
  return res;
};

util.oneOf = function (ele, targetArr) {
  if (targetArr.indexOf(ele) >= 0) {
    return true;
  } else {
    return false;
  }
};

util.showThisRoute = function (itAccess, currentAccess) {
  if (typeof itAccess === 'object' && Array.isArray(itAccess)) {
    return util.oneOf(currentAccess, itAccess);
  } else {
    return itAccess === currentAccess;
  }
};

util.getRouterObjByName = function (routers, name) {
  if (!name || !routers || !routers.length) {
    return null;
  }
  let routerObj = null;
  for (let item of routers) {
    if (item.name === name) {
      return item;
    }
    routerObj = util.getRouterObjByName(item.children, name);
    if (routerObj) {
      return routerObj;
    }
  }
  return null;
};

util.handleTitle = function (vm, item) {
  if (typeof item.title === 'object') {
    return vm.$t(item.title.i18n);
  } else {
    return item.title;
  }
};

util.setCurrentPath = function (vm, name) {
  let title = '';
  let isOtherRouter = false;
  vm.$store.state.app.routers.forEach(item => {
    if (item.children.length === 1) {
      if (item.children[0].name === name) {
        title = util.handleTitle(vm, item);
        if (item.name === 'otherRouter') {
          isOtherRouter = true;
        }
      }
    } else {
      item.children.forEach(child => {
        if (child.name === name) {
          title = util.handleTitle(vm, child);
          if (item.name === 'otherRouter') {
            isOtherRouter = true;
          }
        }
      });
    }
  });
  let currentPathArr = [];
  if (name === 'home_index') {
    currentPathArr = [{
      title: util.handleTitle(vm, util.getRouterObjByName(vm.$store.state.app.routers, 'home_index')),
      path: '',
      name: 'home_index'
    }];
  } else if ((name.indexOf('_index') >= 0 || isOtherRouter) && name !== 'home_index') {
    currentPathArr = [{
      title: util.handleTitle(vm, util.getRouterObjByName(vm.$store.state.app.routers, 'home_index')),
      path: '/sWhome',
      name: 'home_index'
    },
    {
      title: title,
      path: '',
      name: name
    }
    ];
  } else {
    let currentPathObj = vm.$store.state.app.routers.filter(item => {
      if (item.children.length <= 1) {
        return item.children[0].name === name;
      } else {
        let i = 0;
        let childArr = item.children;
        let len = childArr.length;
        while (i < len) {
          if (childArr[i].name === name) {
            return true;
          }
          i++;
        }
        return false;
      }
    })[0];
    if (currentPathObj.children.length <= 1 && currentPathObj.name === 'home') {
      currentPathArr = [{
        title: '首页',
        path: '',
        name: 'home_index'
      }];
    } else if (currentPathObj.children.length <= 1 && currentPathObj.name !== 'home') {
      currentPathArr = [{
        title: '首页',
        path: '/sWhome',
        name: 'home_index'
      },
      {
        title: currentPathObj.title,
        path: '',
        name: name
      }
      ];
    } else {
      let childObj = currentPathObj.children.filter((child) => {
        return child.name === name;
      })[0];
      currentPathArr = [{
        title: '首页',
        path: '/sWhome',
        name: 'home_index'
      },
      {
        title: currentPathObj.title,
        path: '',
        name: currentPathObj.name
      },
      {
        title: childObj.title,
        path: currentPathObj.path + '/' + childObj.path,
        name: name
      }
      ];
    }
  }
  vm.$store.commit('setCurrentPath', currentPathArr);

  return currentPathArr;
};

util.openNewPage = function (vm, name, argu, query, fullPath) {
  // 对首页特殊处理
  if (/^\/home\/\w*/.test(fullPath)) {
    vm.$store.commit('setCurrentPageName', 'home');
    return;
  }
  let routeTable = vm.$router.options.routes;
  let routeKeyValuePair = {};// 路由路径、名称键值对
  routeTable.forEach(item => {
    routeKeyValuePair[item.path] = item.name;
    (item.children || []).forEach(subItem => {
      routeKeyValuePair[item.path + '/' + subItem.path] = subItem.name;
    });
  });
  let menuList = vm.$store.state.app.menuList;
  let menuNames = []; // 用户菜单名称集合
  menuList.forEach(menu => {
    menuNames.push(menu.name);
    (menu.children || []).forEach(child => {
      menuNames.push(child.name);
    });
  });
  if (menuNames.indexOf(name) === -1) {
    // 找出当前页面的父级路径及菜单名，在用户菜单中查找相应的菜单名
    let pathArray = fullPath.split('/');
    pathArray = pathArray.slice(0, pathArray.length - 1);
    for (let i = 0; i < pathArray.length; i++) {
      if (routeKeyValuePair[pathArray.join('/')] && menuNames.indexOf(routeKeyValuePair[pathArray.join('/')]) >= 0) {
        name = routeKeyValuePair[pathArray.join('/')];
        break;
      }
      pathArray = pathArray.slice(0, pathArray.length - 1);
    }
  }
  vm.$store.commit('setCurrentPageName', name);
};

util.toDefaultPage = function (routers, name, route, next) {
  let len = routers.length;
  let i = 0;
  let notHandle = true;
  while (i < len) {
    if (routers[i].name === name && routers[i].children && routers[i].redirect === undefined) {
      route.replace({
        name: routers[i].children[0].name
      });
      notHandle = false;
      next();
      break;
    }
    i++;
  }
  if (notHandle) {
    next();
  }
};

util.fullscreenEvent = function (vm) {
  vm.$store.commit('initCachepage');
  // 权限菜单过滤相关
  vm.$store.commit('updateMenulist');
  // 全屏相关
};

util.testCertId = function (id) {
  let format = /^(([1][1-5])|([2][1-3])|([3][1-7])|([4][1-6])|([5][0-4])|([6][1-5])|([7][1])|([8][1-2]))\d{4}(([1][9]\d{2})|([2]\d{3}))(([0][1-9])|([1][0-2]))(([0][1-9])|([1-2][0-9])|([3][0-1]))\d{3}[0-9xX]$/; // 校验身份证号码正确性
  // 号码规则校验
  if (!format.test(id)) {
    return false;
  }
  // 区位码校验
  // 出生年月日校验   前正则限制起始年份为1900;
  let year = id.substr(6, 4); // 身份证年
  let month = id.substr(10, 2); // 身份证月
  let date = id.substr(12, 2); // 身份证日
  let time = Date.parse(month + '-' + date + '-' + year); // 身份证日期时间戳date
  let nowTime = Date.parse(new Date()); // 当前时间戳
  let dates = (new Date(year, month, 0)).getDate(); // 身份证当月天数
  if (time > nowTime || date > dates) {
    return false;
  }
  // 校验码判断
  var c = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2]; // 系数
  var b = ['1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2']; // 校验码对照表
  var idArray = id.split('');
  var sum = 0;
  for (var k = 0; k < 17; k++) {
    sum += parseInt(idArray[k]) * parseInt(c[k]);
  }
  return idArray[17].toUpperCase() === b[sum % 11].toUpperCase();
};

util.checkParentChildRoutePath = function (parentPath, childPath) {
  let positionIndex = childPath.lastIndexOf('/');
  parentPath = parentPath.split('?')[0];
  if (positionIndex > 0) {
    if (childPath.substring(0, positionIndex) === parentPath) { return true; }
  }
  return false;
};

export default util;



// WEBPACK FOOTER //
// ./src/libs/util.js